import { UATConstants } from 'src/Common/Models/UATConstants';
import { ITenantUIConfig, TenantProvider } from './interface';
import { AMMFilterConfig } from './filters/AMMFilterConfig';

export const AMMTenantConfig: Partial<ITenantUIConfig> = {
  nodeName: [UATConstants.PlaceholdersAndTitles.AMMNode],
  provider: TenantProvider.ADO,
  TenantExperience: true,
  FeatureConfig: {
    SensitiveInfoValidation: false,
    SensativeInfoErrorCount: false,
    AttachmentConfigurations: [],
    Navigation: {
      GlobalSearch: true,
      Copilot: true,
      Analytics: false,
      RequestAccess: true,
      Settings: true,
      Notifications: true,
      Help: true,
    },
    Hub: {
      Filter: true,
      FilterConfig: AMMFilterConfig,
      AreaPath: [UATConstants.AMMAreaPath],
      Title: UATConstants.TenantTitles.AMM,
      ADOTitle: UATConstants.TenantADOText.AMM,
      Create: [],
      hideCreateButton: true,
      BulkUpload: false,
      DownloadTemplate: false,
      Download: true,
      Email: true,
      Task: true,
      LocalSearch: true,
      ColumnOptions: true,
      ColumnOptionsConfig: [],
      SplitMode: true,
      BulkEdit: false,
      BulkEditConfig: [],
      CreateRAID: false,
      DownloadTemplateConfig: {
        tenantToolName: 'amm',
        title: UATConstants.PlaceholdersAndTitles.AMM,
        excelColumnSequence: {
          'Title': 1,
          'Action Owner': 2,
          'Assigned Team': 3,
          'AMM Offer Engine Case ID': 4,
          'AMM Sponsoring Country': 5,
          'AMM_1stYearACR': 6,
          'AMM_3YearACR': 7,
          'AMM_AAOferType': 8,
          'AMM_AccountName': 9,
          'AMM_AccountOwnerID': 10,
          'AMM_ACOCE': 11,
          'AMM_AcoCreditRequestAmount': 12,
          'AMM_ACOID': 13,
          'AMM_ActionTaken': 14,
          'AMM_ActionTakenDetails': 15,
          'AMM_AdditionalAttendeesEmail': 16,
          'AMM_AEAlias': 17,
          'AMM_AEATSEmailAddress': 18,
          'AMM_AppSSPAlias': 19,
          'AMM_ATSAlias': 20,
          'AMM_AttachRequireddocuments': 21,
          'AMM_AVSOffer': 22,
          'AMM_AVSRIQuantity': 23,
          'AMM_AVSRIRegion': 24,
          'AMM_CancellationAdditionalDetails': 25,
          'AMM_CancellationReason': 26,
          'AMM_CaseCreatedDateTime': 27,
          'AMM_CaseDuration': 28,
          'AMM_CaseNotes': 29,
          'AMM_CCRecipient': 30,
          'AMM_CommunicationPreference': 31,
          'AMM_CSA2EmailAddress': 32,
          'AMM_CSA3EmailAddress': 33,
          'AMM_CSAEmailAddress': 34,
          'AMM_CustomerAcceptedTheAssessment': 35,
          'AMM_CustomerCCList': 36,
          'AMM_CustomerCommitment': 37,
          'AMM_CustomerContactEmail': 38,
          'AMM_CustomerContactName': 39,
          'AMM_CustomerIntendToDeploytheNewAVSRIs': 40,
          'AMM_DealStructure': 41,
          'AMM_DeliveryPartnerEligibility': 42,
          'AMM_DisqualificationAdditionalReason': 43,
          'AMM_DisqualificationReason': 44,
          'AMM_DoesThisIncludeHighRiskDeal': 45,
          'AMM_DoyouwanttorequestACOinadditiontoECIF': 46,
          'AMM_ECIFSpendPlan': 47,
          'AMM_EnrollmentID': 48,
          'AMM_EnrollmentNoOrBillingAcID': 49,
          'AMM_EnrollmentNumberorBillingAccountIDifexistingAccountonly': 50,
          'AMM_ESI': 51,
          'AMM_ExpectedProjectEndDate': 52,
          'AMM_ExpectedProjectStartDate': 53,
          'AMM_FinancialYear': 54,
          'AMM_FTA': 55,
          'AMM_FundingCE': 56,
          'AMM_FundingID': 57,
          'AMM_FutureGrowthECIF': 58,
          'AMM_FutureGrowthOffer': 59,
          'AMM_HelpCategory': 60,
          'AMM_HelpDescription': 61,
          'AMM_IncrementalRevenueROI': 62,
          'AMM_IsThereACompetitiveBid': 63,
          'AMM_IsThereanyExistingMACCCTCMC': 64,
          'AMM_IsThereAnyExistingMACCOrCTCOrMC': 65,
          'AMM_IsThereExistingACO': 66,
          'AMM_IsThisAssessmentMeantToAddressAppMigration': 67,
          'AMM_IsThisAVMCToAVSMigration': 68,
          'AMM_IsThisRequestRelatedToPublicOrGovernmentOwnedEntity': 69,
          'AMM_MicrosoftCCRecipient': 70,
          'AMM_MicrosoftDefenderforCloud': 71,
          'AMM_Migrationormodernization': 72,
          'AMM_MigrationPartner': 73,
          'AMM_MigrationPartnerAttached': 74,
          'AMM_MigrationPartnerEmail': 75,
          'AMM_MilestoneIds': 76,
          'AMM_Needawaveplan': 77,
          'AMM_NeedhelpPitchingTheValue': 78,
          'AMM_NeedWavePlanASSBreakagedependencies': 79,
          'AMM_NextBestAction': 80,
          'AMM_NextBestActionDetails': 81,
          'AMM_NonRecurring': 82,
          'AMM_Offer': 83,
          'AMM_OfferEngineStatus': 84,
          'AMM_OriginatingCaseID': 85,
          'AMM_PendingActionFrom': 86,
          'AMM_PlannedQuantityofAVSRIs1or3YRRI': 87,
          'AMM_PreOrPost': 88,
          'AMM_PRIMARYAzurevirtualmachineVMseries': 89,
          'AMM_PrimarySolutionPlay': 90,
          'AMM_Program': 91,
          'AMM_ProgramFunding': 92,
          'AMM_ProjectAdditionalDetails': 93,
          'AMM_ProjectSize': 94,
          'AMM_RejectionAdditionalDetails': 95,
          'AMM_RejectionReason': 96,
          'AMM_RequestAmount': 97,
          'AMM_RequestJustification': 98,
          'AMM_RequestReason': 99,
          'AMM_RequestType': 100,
          'AMM_RIValuePerMonth': 101,
          'AMM_SAPOffer': 102,
          'AMM_ScopeOfWork': 103,
          'AMM_SecuritySSPAlias': 104,
          'AMM_ServiceLocation': 105,
          'AMM_SLARemainingTime': 106,
          'AMM_SolutionAssessmentType': 107,
          'AMM_SpecialistEmailAddress': 108,
          'AMM_SponsorshipAmount': 109,
          'AMM_SSOrTSAlias': 110,
          'AMM_SubTitle': 111,
          'AMM_SupportedScenario': 112,
          'AMM_SupportRegion': 113,
          'AMM_TermsAndConditionEmailID': 114,
          'AMM_TotalACR': 115,
          'AMM_TotalForOfferEligibleACR': 116,
          'AMM_TypeofFundingNeeded': 117,
          'AMM_WillthisrequestrequireadditionalAttendees': 118,
          'ControlExtensionMultivalueDropdown': 119,
        },
      },
    },
    ManageAction: {
      NewExperience: true,
      MandateFormPickers: [
        {
          formFieldName: 'actionOwner',
          formFieldLabel: UATConstants.PlaceholdersAndTitles.ActionOwner,
          apiFieldName: 'assignedto',
        },
        {
          formFieldName: 'requestOnBehalfOf',
          formFieldLabel: UATConstants.PlaceholdersAndTitles.RequestOnBehalfOf,
          apiFieldName: 'requestorsinfo',
        },
        //For hot fix we are add few more non mandatory fields in mandate section : Start
        {
          formFieldName: 'microsoftCCRecipient',
          formFieldLabel: UATConstants.PlaceholdersAndTitles.MicrosoftCCRecipient,
          apiFieldName: 'microsoftCcRecipient',
        },
        {
          formFieldName: 'contributor1',
          formFieldLabel: UATConstants.PlaceholdersAndTitles.Contributor1,
          apiFieldName: 'contributorsinfo',
        },
        {
          formFieldName: 'contributor2',
          formFieldLabel: UATConstants.PlaceholdersAndTitles.Contributor2,
          apiFieldName: 'contributorsinfo',
        },
        {
          formFieldName: 'triageOwner',
          formFieldLabel: UATConstants.PlaceholdersAndTitles.AMMTriageOwner,
          apiFieldName: 'triageOwner',
        },

        // Following fields are commented as per the request from AMM team on 6th Oct 2025 release.
        // {
        //   formFieldName: 'ACOCE',
        //   formFieldLabel: UATConstants.PlaceholdersAndTitles.ACOCE,
        //   apiFieldName: 'acoce',
        // },
        // {
        //   formFieldName: 'csamName',
        //   formFieldLabel: UATConstants.PlaceholdersAndTitles.CSAMName,
        //   apiFieldName: 'csamName',
        // },
        // {
        //   formFieldName: 'CSASecurity',
        //   formFieldLabel: UATConstants.PlaceholdersAndTitles.CSASecurity,
        //   apiFieldName: 'csaSecurity',
        // },
        // {
        //   formFieldName: 'csaEmail',
        //   formFieldLabel: UATConstants.PlaceholdersAndTitles.CSAEmail,
        //   apiFieldName: 'csaEmailAddress',
        // },
        //  {
        //   formFieldName: 'csa2Email',
        //   formFieldLabel: UATConstants.PlaceholdersAndTitles.CSA2Email,
        //   apiFieldName: 'csa2EmailAddress',
        // },
        // {
        //   formFieldName: 'csa3Email',
        //   formFieldLabel: UATConstants.PlaceholdersAndTitles.CSA3Email,
        //   apiFieldName: 'csa3EmailAddress',
        // },
        // {
        //   formFieldName: 'AEATSEmail',
        //   formFieldLabel: UATConstants.PlaceholdersAndTitles.AEATSEmail,
        //   apiFieldName: 'aeAtsEmailAddress',
        // },
        // {
        //   formFieldName: 'specialistEmail',
        //   formFieldLabel: UATConstants.PlaceholdersAndTitles.SpecialistEmail,
        //   apiFieldName: 'specialistEmailAddress',
        // },
        //End
      ],
      AllowedOfferKeysForValidation: [
        //ECIF Offers
        ...UATConstants.ECIFOffersKeysList,

        //ACO Offers
        ...UATConstants.ACOOffersKeysList,

        //Azure Access Offers
        UATConstants.UATFields.AMM_OFFER_AMMAPAzureAccess,
      ],
      AllowedOfferKeysForCaseTracking: [
        ...UATConstants.ECIFOffersKeysList,
        ...UATConstants.ACOOffersKeysList,
        ...UATConstants.CMFOffersKeysList,
        UATConstants.UATFields.AMM_OFFER_AMMAPAzureAccess,
        UATConstants.UATFields.AMM_OFFER_MigrateAndSecureSolutionAssessment,
      ],
      Header: {
        Tags: true,
        Actions: {
          Follow: true,
          Email: true,
          CopyLink: true,
        },
      },
      Tabs: {
        TechnicalFeedback: false,
        RelatedItems: {
          showRelatedTab: true,
          showTFTCreated: false,
        },
        Attachments: true,
        History: true,
        NBAR: true,
      },
      Panes: {
        CopilotInsights: {
          CustomerInsights: true,
          DiscussionInsights: true,
        },
        StatusUpdate: true,
        ClosureStatement: true,
        Discussion: true,
        Tasks: true,
        EmailConversation: false,
      },
    },
    ManageView: {
      showAddViewButton: true,
      showAddFolderButton: true,
      showCommandBar: true,
      showPreviewFeatureMessageBar: false,
      showSelectFields: false,
      defaultViewId: '35a2abd7-9e87-4c83-9e53-7d4bb39f3a5f',
      systemViewsFolderId: '8a6f0acb-4b35-48c6-98e2-ab28762a2a8b',
      sharedViewsFolderId: '7e5c59b8-7d30-4094-b339-70af94473336',
    },
  }
};
